import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../../i18n';
import { getSavedLooks, toggleSavedLook } from './savedLookStore';

const fallbackImage =
  'https://images.unsplash.com/photo-1485968579580-b6d095142e6e?auto=format&fit=crop&w=1400&q=80';

function avatarImageUrl(url) {
  if (!url) return '';
  const value = String(url);
  if (value.startsWith('/media/') || value.startsWith('/outfit-detective/') || value.includes('/outfit-detective/')) return value;
  return `/api/media/avatar?url=${encodeURIComponent(url)}`;
}

export default function SavedLooks() {
  const { formatDate, t } = useI18n();
  const [looks, setLooks] = useState(() => getSavedLooks());

  useEffect(() => {
    function refreshSavedLooks() {
      setLooks(getSavedLooks());
    }

    window.addEventListener('od:saved-looks-change', refreshSavedLooks);
    window.addEventListener('storage', refreshSavedLooks);
    return () => {
      window.removeEventListener('od:saved-looks-change', refreshSavedLooks);
      window.removeEventListener('storage', refreshSavedLooks);
    };
  }, []);

  function removeLook(event) {
    toggleSavedLook(event);
    setLooks(getSavedLooks());
  }

  if (looks.length === 0) {
    return (
      <section className="ct-saved-page">
        <div className="ct-card ct-empty">
          <h2>{t('saved.emptyTitle')}</h2>
          <p>{t('saved.emptyCopy')}</p>
          <Link to="/" className="btn btn-dark">{t('saved.emptyCta')}</Link>
        </div>
      </section>
    );
  }

  return (
    <section className="ct-saved-page">
      <div className="ct-panel-heading">
        <div>
          <p className="ct-kicker">{t('saved.kicker')}</p>
          <h2>{t('saved.title')}</h2>
        </div>
      </div>
      <div className="ct-saved-grid">
        {looks.map((event) => (
          <article className="ct-saved-card" key={event.id}>
            <Link to={`/events/${event.id}`} className="ct-saved-media">
              <img src={event.image_url || fallbackImage} alt={event.title} />
            </Link>
            <div className="ct-saved-body">
              <div className="ct-post-head no-padding">
                <Link to={`/following/${event.celebrity_slug}`} className="ct-avatar small">
                  {event.celebrity_image_url ? (
                    <img src={avatarImageUrl(event.celebrity_image_url)} alt={event.celebrity_name} />
                  ) : (
                    (event.celebrity_name || '?').slice(0, 1).toUpperCase()
                  )}
                </Link>
                <div>
                  <Link to={`/following/${event.celebrity_slug}`}>
                    <strong>{event.celebrity_name}</strong>
                  </Link>
                  <span>{formatDate(event.saved_at, { dateStyle: 'medium' })}</span>
                </div>
              </div>
              <h3>{event.title}</h3>
              <div className="ct-saved-actions">
                <Link to={`/events/${event.id}`}>{t('saved.open')}</Link>
                <button type="button" onClick={() => removeLook(event)}>{t('saved.remove')}</button>
              </div>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
